module.exports = __webpack_public_path__ + "static/media/Mouth v1.a7d82af0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Mouth v1.png
// module id = 1177
// module chunks = 0